<template>
  <div>
  </div>
</template>

<script>

export default {
  name: 'ReleaseCreate',
  props: {
    type: {
      type: String,
      default: 'album',
    },
  },
  mounted() {
    // セッションストレージをクリアする
    window.sessionStorage.setItem('album', JSON.stringify({
      artists: [],
      status: 0,
      type: this.type,
      artistType: 1,
      jacketImage: null,
      product: {},
      discs: [{ tracks: [] }],
      store: {
        simultaneous_release: false,
        publish_date: '',
        single_price: '',
        package_price: '',
        hi_res_single_price: '',
        hi_res_package_price: '',
        country: 'WW',
      },
      providers: {},
      releasedProviders: {},
      providerSchedules: {},
    }))

    this.$router.push({ name: `release-${this.type}-step1` })
  },
}
</script>
